import { Maybe } from "../models/generated/graphql";

export function tryDeserialize(snapshot: Maybe<string>, defaultValue: any = null) {
	try {
		return (snapshot && JSON.parse(snapshot)) || defaultValue;
	} catch {
		return defaultValue;
	}
}
